export default __webpack_public_path__ + "static/media/FrontCover.27704d9a.txt";